import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
import { actions as checkActions, selectors as checkSelectors } from "reducers/checks";
import MainContainer from "pages/_components/MainContainer";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import { Col, Row } from "react-bootstrap";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import Button from "pages/_components/Button";
import Credential from "pages/_components/fields/credentials/Credential";
import gaEventTracker, { events } from "util/gaEventTracker";
import { arrayOf, func, shape, string } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CheckbookSummary from "./components/CheckbookSummary";

const NewCheckbookSummaryForm = ({
    newCheckbookRequest,
    newCheckbookTicketStatus,
    newCheckbookRequiredCredentials,
    newCheckbookTicketId,
    dispatch,
}) => {
    const isLoading = newCheckbookRequest.checksAccountSelector === "";
    const [isValidating, setIsValidating] = useState(true);
    const credentialType = newCheckbookRequiredCredentials.includes("otp") ? "otp" : "password";
    const [formRef, setFormRef] = useState();

    useEffect(() => {
        if (newCheckbookTicketStatus === "INVALID_CREDENTIAL") {
            setIsValidating(false);
            formRef.setErrors({
                credential: i18n.get(
                    credentialType === "password"
                        ? "preferences.password.password.incorrect"
                        : "login.step1.secondFactor.invalid",
                ),
            });
        } else if (newCheckbookTicketStatus === "AWAITING_BACKOFFICE_SIGNATURE") {
            dispatch(routerActions.push(`/checks/pendingBackofficeApprove/${newCheckbookTicketId}`));
        } else if (newCheckbookTicketStatus === "PENDING_USER_SIGNATURES") {
            dispatch(routerActions.push(`/checks/pendingUserSignatures/${newCheckbookTicketId}`));
        }
    }, [isValidating, formRef, newCheckbookTicketStatus, newCheckbookTicketId]);

    useEffect(() => {
        dispatch(checkActions.fetchCredentialGroup());
    }, [dispatch]);

    const handleSubmit = ({ credential }) => {
        setIsValidating(true);
        gaEventTracker.triggerEvent(
            events.newCheckbook({
                echeqs: newCheckbookRequest?.checksPerCheckbook,
                quantity: newCheckbookRequest?.checkbookAmount,
            }),
        );
        if (newCheckbookRequest?.idTransaction) {
            dispatch(
                checkActions.setNewCheckbookCredential({
                    idTransaction: newCheckbookRequest?.idTransaction,
                    [`_${credentialType}`]: credential,
                }),
            );
        } else {
            dispatch(
                checkActions.setNewCheckbookCredential({
                    ...newCheckbookRequest,
                    [`_${credentialType}`]: credential,
                }),
            );
        }
    };

    const handleBack = () => {
        dispatch(checkActions.setNewCheckbookShouldShowLastValues(true));
        dispatch(routerActions.goBack());
    };

    return (
        <Fragment>
            <CustomProductHead titleId="checks.create.title" exportList="global.download" onBack={handleBack}>
                <div className="toolbar-item view-title">
                    <ViewTitle id="checks.create.title" />
                </div>
            </CustomProductHead>
            <MainContainer showLoader={isLoading}>
                <div className="container">
                    {/* <TransactionCard transaction={transaction}>
                        <TransactionHeader title={"checks.control.title"} /> */}
                    <GridTable className="form-summary">
                        <CheckbookSummary
                            title="checks.control.title"
                            checksAccountSelected={newCheckbookRequest?.checksAccountSelected}
                            checksPerCheckbook={newCheckbookRequest?.checksPerCheckbook}
                            checkbookAmount={newCheckbookRequest?.checkbookAmount}
                            retrieverId={newCheckbookRequest?.retrieverId}
                            firstName={newCheckbookRequest?.firstName}
                            lastName={newCheckbookRequest?.lastName}
                        />
                    </GridTable>
                    {/* </TransactionCard> */}
                    {/* <div className="transaction-ticket">
                        <Row className="form-confirmation-container">
                            <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}></Col>
                        </Row>
                    </div> */}
                    <Formik
                        ref={(el) => setFormRef(el)}
                        validateOnBlur
                        validateOnChange={false}
                        initialValues={{
                            credential: "",
                        }}
                        validationSchema={Yup.object().shape({
                            credential: Yup.string().required(i18n.get("deposits.request.required")),
                        })}
                        onSubmit={handleSubmit}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Row className="forsssm-actions">
                                    <Col xs={12} md={4} mdOffset={2} lg={3} lgOffset={3}>
                                        <Field
                                            idForm="form.credential"
                                            name="credential"
                                            labelText={`form.credential.${credentialType}.label`}
                                            placeholderText="Ej: 120573"
                                            component={Credential}
                                            type={credentialType}
                                        />
                                    </Col>
                                    <Col xs={12} md={4} mdOffset={6} lg={3} lgOffset={6} className="align-items-end">
                                        <div className="form-group hidden-label">
                                            <div className="button-group ">
                                                <Button
                                                    block
                                                    type="submit"
                                                    label="global.send"
                                                    bsStyle="primary"
                                                    loading={isSubmitting && isValidating}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </div>
            </MainContainer>
        </Fragment>
    );
};

NewCheckbookSummaryForm.propTypes = {
    newCheckbookRequest: shape({}),
    newCheckbookTicketStatus: string.isRequired,
    newCheckbookRequiredCredentials: arrayOf(string).isRequired,
    newCheckbookTicketId: string.isRequired,
    dispatch: func.isRequired,
};
NewCheckbookSummaryForm.defaultProps = {
    newCheckbookRequest: {},
};

const mapStateToProps = (state) => ({
    newCheckbookRequest: checkSelectors.getNewCheckbookRequest(state),
    newCheckbookRequiredCredentials: checkSelectors.getNewCheckbookRequiredCredentials(state),
    newCheckbookTicketStatus: checkSelectors.getCheckbookTicketStatus(state),
    newCheckbookTicketId: checkSelectors.getCheckbookTicketId(state),
});

export default connect(mapStateToProps)(NewCheckbookSummaryForm);
